
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.882 9.465A.15.15 0 007 9.523a.149.149 0 00.118-.058l2.096-2.677a.15.15 0 00-.118-.244H7.71V.151A.15.15 0 007.56 0H6.437a.15.15 0 00-.15.151v6.391H4.904a.15.15 0 00-.118.244l2.096 2.679zm6.968-.661h-1.123a.151.151 0 00-.15.15v2.91H1.423v-2.91a.15.15 0 00-.15-.15H.15a.15.15 0 00-.15.15v3.741c0 .335.268.605.599.605h12.802c.331 0 .599-.27.599-.605v-3.74a.15.15 0 00-.15-.151z","fill":"#fff"}})])
          )
        }
      }
    